export default __webpack_public_path__ + "maps-overview-quickstart-result-1200-ec2a9fcd02f4947768193529c29fdff4.webp";